import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { AppHelper } from "../appHelper";
import { StringKeyDictionary } from "../commonInterfaces";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { Grid } from "../core/components/grid";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Travel, TravelReportFilter, TravelReportRights } from "./travelReportInterfaces";
import React from "react";
export class CreateTravelReportApp extends React.Component<CreateTravelReportProps, CreateTravelReportState>
{
    common = new AppHelper();
    travelGridOptions: {};
    translations: StringKeyDictionary<string> = null;

    constructor(props: CreateTravelReportProps) {
        super(props);
        this.common.init(this);
        this.state = {
            travels: null,
            selectedTravel: null,
            filter: this.props.entity.filter
        }
    }

    componentDidMount = () => {
        this.getTravelInfos();
    }

    getTravelInfos = async () => {
        let filter: TravelReportFilter = {
            RessNr: this.state.filter.RessNr,
            Start: null,
            End: null,
            NotApproved: false,
            NotInvoiced: false,
            NotCompleted: false
        }

        let result = await HTTPService.get<JsonResultClass<Travel[]>>("TravelReportCreate/GetTravelInfos", filter);
        if (result.Code == 0) {
            var travels = result.Data;
            this.setState({ travels: travels });
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    createTravelReport = async () => {
        var filter: TravelReportFilter = this.state.filter;
        let result = await HTTPService.get<JsonResultClass<number>>
            ("TravelReportCreate/CreateTravelReport", filter);
        if (result.Code == 0) {
            var travelReportNr = result.Data;
            NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
            this.closeWindow();
            this.openEditTravelReport(travelReportNr);
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    closeWindow = () => {
        if (this.common.isWindow) {
            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
            this.common.sheetWrapper.hide();
        } else {
            this.props.entity.RecordRight.CanWrite = false;
            this.setState({});
            setTimeout(() => {
                window.location.href = Config.baseUrl + "DynamicSearch/travelReport";
            }, 1000);
        }
    }

    openEditTravelReport = (travelReportNr: number) => {
        const url = "TravelReport/Edit?id=" + encodeURIComponent(travelReportNr);
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.filter.Start":
                this.handleFilterChange(field, value);
                break;
            case "entity.filter.End":
                this.handleFilterChange(field, value);
                break;
            case "entity.filter.RessNr":
                this.handleFilterChange(field, value);
                break;
        }
        this.common.setEntityDirtyState(false);
    }

    handleFilterChange(field: { model: string }, value) {
        var filter = this.state.filter;
        switch (field.model) {
            case "entity.filter.Start":
                filter.Start = value;
                break;
            case "entity.filter.End":
                filter.End = value;
                break;
            case "entity.filter.RessNr":
                filter.RessNr = value;
                break;
        }
        this.setState({ filter: filter }, () => {
            if (field.model == "entity.filter.RessNr")
                this.getTravelInfos();
        });
    }

    handleClickCustomButton = (id: string) => {
        let filter = this.state.filter;
        switch (id) {
            case "getStart":
                filter.Start = this.state.selectedTravel.Start
                break;
            case "getEnd":
                filter.End = this.state.selectedTravel.End
                break;
            case "getStartAndEnd":
                filter.Start = this.state.selectedTravel.Start;
                filter.End = this.state.selectedTravel.End;
                break;
        }
        this.setState({ filter: filter });
    }

    renderTravelGrid = () => {
        if (!Helper.hasValue(this.state.travels))
            return null;

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "getStart", enabled: Helper.hasValue(this.state.selectedTravel), caption: this.translations["WebSMS.TravelReport.ApplyStart"], iconClass: "fas fa-reply", autoEnabledOnRecordSelected: false, useContextMenu: true
        });
        customButtons.push({
            id: "getEnd", enabled: Helper.hasValue(this.state.selectedTravel), caption: this.translations["WebSMS.TravelReport.ApplyEnd"], iconClass: "fas fa-reply", autoEnabledOnRecordSelected: false, useContextMenu: true
        });
        customButtons.push({
            id: "getStartAndEnd", enabled: Helper.hasValue(this.state.selectedTravel), caption: this.translations["WebSMS.TravelReport.ApplyPeriod"], iconClass: "fas fa-reply", autoEnabledOnRecordSelected: false, useContextMenu: true
        });

        var content = <Grid data={this.state.travels} options={this.travelGridOptions} id="createTravelGrid" onSelectionChanged={(dataItem: Travel) => { this.setState({ selectedTravel: dataItem }) }}
            customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton} />
        return content;
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface CreateTravelReportProps extends AppBaseProps {
    entity: CreateTravelReportEntity;
}

export interface CreateTravelReportEntity extends Entity {
    filter: TravelReportFilter;
    RecordRight: TravelReportRights;
}

export interface CreateTravelReportState {
    filter: TravelReportFilter;
    travels: Travel[];
    selectedTravel: Travel;
}